import VueVectorMap from "vuevectormap";
// Import world map from jsvectormap
import "jsvectormap/dist/maps/world";

import "jsvectormap/dist/jsvectormap.css";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueVectorMap, {
    map: "world",
    // Set global options
    backgroundColor: "transparent",
  });
});
